import { Profile, Stake, TradeFill } from '@ui/components/icons';
import { BrandNavItemKey } from '@ui/config/brand';
import { ROUTES } from '@ui/constants/routes';
import { Icon } from '@ui/lib/park/ui/icon';
import { TFunction } from 'next-i18next';
import { ReactNode } from 'react';
import { styled } from 'styled-system/jsx';

export type NavRouteItem = {
  key: BrandNavItemKey;
  url: ROUTES;
  content: ReactNode;
  label: ReactNode;
  /** Token/brand icon shown before the name in the desktop nav. */
  tokenIcon?: string;
  /** Use the active brand color for monochrome nav icons. */
  tintIcon?: boolean;
  mobileOnly?: boolean;
};

export const getRoutesArray = (t: TFunction) =>
  [
    {
      key: 'trade',
      url: ROUTES.INDEX,
      content: (
        <>
          <Icon>
            <TradeFill />
          </Icon>
          {t('common.Trade')}
        </>
      ),
      label: t('common.Trade'),
      tokenIcon: '/icons/trade-fill.svg',
      tintIcon: true,
    },
    {
      key: 'LVUSD',
      url: ROUTES.LVUSD,
      content: (
        <>
          <styled.img src="/tokens/LVUSD.svg" width="20px" height="20px" />
          {t('common.LVUSD')}
        </>
      ),
      label: t('common.LVUSD'),
      tokenIcon: '/tokens/LVUSD.svg',
    },
    {
      key: 'LVMON',
      url: ROUTES.LVMON,
      content: (
        <>
          <styled.img src="/tokens/LVMON.svg" width="20px" height="20px" />
          {t('common.LVMON')}
        </>
      ),
      label: t('common.LVMON'),
      tokenIcon: '/tokens/LVMON.svg',
    },
    {
      key: 'fairlaunch',
      url: ROUTES.FAIRLAUNCH,
      content: t('common.Fairlaunch', 'Fair Launch'),
      label: t('common.Fairlaunch', 'Fair Launch'),
      tokenIcon: '/icons/discover-fill.svg',
      tintIcon: true,
    },
    {
      key: 'earn',
      url: ROUTES.EARN,
      content: (
        <>
          <Icon>
            <Stake />
          </Icon>
          {t('common.Earn')}
        </>
      ),
      label: t('common.Earn'),
      tokenIcon: '/icons/stake.svg',
      tintIcon: true,
    },
    {
      key: 'airdrop',
      url: ROUTES.AIRDROP,
      content: (
        <>
          <styled.img src="/tokens/LV.svg" width="20px" height="20px" />
          {t('common.Airdrop')}
        </>
      ),
      label: t('common.LV Airdrop'),
      tokenIcon: '/tokens/LV.svg',
    },
    {
      key: 'competition',
      url: ROUTES.COMPETITION,
      content: (
        <>
          <Icon>
            <TradeFill />
          </Icon>
          {t('common.Competition', 'Competition')}
        </>
      ),
      label: t('common.Competition', 'Competition'),
      tokenIcon: '/icons/trophy.svg',
      tintIcon: true,
    },
    {
      key: 'portfolio',
      url: ROUTES.PORTFOLIO,
      content: (
        <>
          <Icon>
            <Profile />
          </Icon>
          {t('common.Portfolio', 'Portfolio')}
        </>
      ),
      label: t('common.Portfolio', 'Portfolio'),
      mobileOnly: true,
    },
  ] satisfies NavRouteItem[];
